module.exports = __webpack_public_path__ + "static/torn-bg-white-b-3ade8950e890a82903d7804945fe9a07.png";